import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/117ff92a-f074-4482-9d63-e13f7e004125";
export const REGISTER_URL = "https://a.ntrk2.com/82327715-9245-4f9b-aa48-91214508921f";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowgana.kzw2a.com/download?openExternalBrowser=1&id=zv1w2rmj8adev3d";

export * from "./codes";
export * from "./context";
